import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import CropSpeciesPopup from "../Popups/CropSpeciesPopup.jsx";
import IrrigationPopup from "../Popups/IrrigationPopup.jsx";
import WaterMgmtToolsPopup from "../Popups/WaterMgmtToolsPopup.jsx";
import DynamicDialog from "../../components/Dialogs/Dialog.jsx";
import * as helpers from "../../helpers/helpers.js";
import greencheckmarkicon from "./images/green-check-mark-icon.png";

export default function UserDetails(props) {
	const {
		handleSave,
		fieldDetails,
		detailsAdded,
		parentprespeciescroponeyearonechange,
		parentprespeciescroptwoyearonechange,
		parentprespeciescropthreeyearonechange,
		parentprespeciescroponeyeartwochange,
		parentprespeciescroptwoyeartwochange,
		parentprespeciescropthreeyeartwochange,
		parentprespeciescroponeyearthreechange,
		parentprespeciescroptwoyearthreechange,
		parentprespeciescropthreeyearthreechange,
		parentpostspeciescroponeyearonechange,
		parentpostspeciescroptwoyearonechange,
		parentpostspeciescropthreeyearonechange,
		parentpostspeciescroponeyeartwochange,
		parentpostspeciescroptwoyeartwochange,
		parentpostspeciescropthreeyeartwochange,
		parentpostspeciescroponeyearthreechange,
		parentpostspeciescroptwoyearthreechange,
		parentpostspeciescropthreeyearthreechange,
		parentcropagechange,
		parentpreirrchange,
		parentpostirrchange,
		parentpresoilmoisturechange,
		parentpreflowchange,
		parentpreetchange,
		parentprenochange,
		parentpostsoilmoisturechange,
		parentpostflowchange,
		parentpostetchange,
		parentprespeciescrop1verticalchange,
		parentprespeciescrop2verticalchange,
		parentprespeciescrop3verticalchange,
		parentpostspeciescrop1verticalchange,
		parentpostspeciescrop2verticalchange,
		parentpostspeciescrop3verticalchange,
	} = props;

	const [croppingOpen, setCroppingOpen] = React.useState(false);
	const [irrigationOpen, setIrrigationOpen] = React.useState(false);
	const [waterOpen, setWaterOpen] = React.useState(false);

	const handleClickCroppingOpen = () => {
		setCroppingOpen(true);
	};
	const handleClickIrrigationOpen = () => {
		setIrrigationOpen(true);
	};
	const handleClickWaterOpen = () => {
		setWaterOpen(true);
	};
	function handleSaveDialog() {
		handleSave(false);
		checkCropComplete();
		checkIrrigationComplete();
		checkWaterManagementComplete();
		setCroppingOpen(false);
		setIrrigationOpen(false);
		setWaterOpen(false);
	}

	useEffect(() => {
		if (fieldDetails != undefined) {
			checkCropComplete();
			checkIrrigationComplete();
			checkWaterManagementComplete();
		}
	}, [detailsAdded]);

	function checkCropComplete() {
		const noSelectionId = "1";

		if (
			!!fieldDetails.precropping.preyearcroponeyearone &&
			fieldDetails.precropping.preyearcroponeyearone !== noSelectionId &&
			!!fieldDetails.precropping.preyearcroponeyeartwo &&
			fieldDetails.precropping.preyearcroponeyeartwo !== noSelectionId &&
			!!fieldDetails.precropping.preyearcroponeyearthree &&
			fieldDetails.precropping.preyearcroponeyearthree !== noSelectionId &&
			!!fieldDetails.postcropping.postyearcroponeyearone &&
			fieldDetails.postcropping.postyearcroponeyearone !== noSelectionId &&
			!!fieldDetails.postcropping.postyearcroponeyeartwo &&
			fieldDetails.postcropping.postyearcroponeyeartwo !== noSelectionId &&
			!!fieldDetails.postcropping.postyearcroponeyearthree &&
			fieldDetails.postcropping.postyearcroponeyearthree !== noSelectionId
		) {
			document.getElementById("cropComplete").style.display = "inline-block";
		} else {
			document.getElementById("cropComplete").style.display = "none";
		}
	}

	function checkIrrigationComplete() {
		const emptyValue = "";
		if (
			!!fieldDetails.preirr &&
			fieldDetails.preirr !== emptyValue &&
			!!fieldDetails.postirr &&
			fieldDetails.postirr !== emptyValue
		) {
			document.getElementById("irrcomplete").style.display = "inline-block";
		} else {
			document.getElementById("irrcomplete").style.display = "none";
		}
	}

	function checkWaterManagementComplete() {
		if (
			Object.values(fieldDetails.prewater).some((value) => value) &&
			Object.values(fieldDetails.postwater).some((value) => value)
		) {
			document.getElementById("watercomplete").style.display = "inline-block";
		} else {
			document.getElementById("watercomplete").style.display = "none";
		}
	}

	const saveButton = helpers.getDialogButton("Save", handleSaveDialog);

	const getCroppingSysForm = () => {
		return (
			<CropSpeciesPopup
				fieldDetails={fieldDetails}
				parentPreCropOneYearOneChange={parentprespeciescroponeyearonechange}
				parentPreCropOneYearTwoChange={parentprespeciescroponeyeartwochange}
				parentPreCropOneYearThreeChange={parentprespeciescroponeyearthreechange}
				parentPreCropTwoYearOneChange={parentprespeciescroptwoyearonechange}
				parentPreCropTwoYearTwoChange={parentprespeciescroptwoyeartwochange}
				parentPreCropTwoYearThreeChange={parentprespeciescroptwoyearthreechange}
				parentPreCropThreeYearOneChange={parentprespeciescropthreeyearonechange}
				parentPreCropThreeYearTwoChange={parentprespeciescropthreeyeartwochange}
				parentPreCropThreeYearThreeChange={parentprespeciescropthreeyearthreechange}
				parentPostcropOneYearOneChange={parentpostspeciescroponeyearonechange}
				parentPostcropOneYearTwoChange={parentpostspeciescroponeyeartwochange}
				parentPostcropOneYearThreeChange={parentpostspeciescroponeyearthreechange}
				parentPostcropTwoYearOneChange={parentpostspeciescroptwoyearonechange}
				parentPostcropTwoYearTwoChange={parentpostspeciescroptwoyeartwochange}
				parentPostcropTwoYearThreeChange={parentpostspeciescroptwoyearthreechange}
				parentPostcropThreeYearOneChange={parentpostspeciescropthreeyearonechange}
				parentPostcropThreeYearTwoChange={parentpostspeciescropthreeyeartwochange}
				parentPostcropThreeYearThreeChange={parentpostspeciescropthreeyearthreechange}
				parentCopyPreCrop1VerticalChange={parentprespeciescrop1verticalchange}
				parentCopyPreCrop2VerticalChange={parentprespeciescrop2verticalchange}
				parentCopyPreCrop3VerticalChange={parentprespeciescrop3verticalchange}
				parentCopyPostCrop1VerticalChange={parentpostspeciescrop1verticalchange}
				parentCopyPostCrop2VerticalChange={parentpostspeciescrop2verticalchange}
				parentCopyPostCrop3VerticalChange={parentpostspeciescrop3verticalchange}
				handleCropAgeChange={parentcropagechange}
			/>
		);
	};

	const getPreIrrigationSysForm = () => {
		return (
			<IrrigationPopup
				fieldDetails={fieldDetails}
				parentPreIrrChange={parentpreirrchange}
				parentPostIrrChange={parentpostirrchange}
			/>
		);
	};

	const getWaterMgmtToolsForm = () => {
		return (
			<WaterMgmtToolsPopup
				fieldDetails={fieldDetails}
				parentPreSMChange={parentpresoilmoisturechange}
				parentPreFLChange={parentpreflowchange}
				parentPreETChange={parentpreetchange}
				parentPreNOChange={parentprenochange}
				parentPostSMChange={parentpostsoilmoisturechange}
				parentPostFLChange={parentpostflowchange}
				parentPostETChange={parentpostetchange}
			/>
		);
	};

	return (
		<div style={{ marginTop: 10, paddingRight: 50 }}>
			<GridContainer direction="column" justifyContent="flex-start" alignItems="flex-start">
				<GridItem xs={12} sm={12} md={12}>
					<DynamicDialog
						buttons={[saveButton]}
						open={croppingOpen}
						labelId={"showCroppingOpenDialog"}
						title={"Cropping System"}
						textMessage={""}
						form={getCroppingSysForm()}
					/>
				</GridItem>

				<GridItem xs={12} sm={12} md={12}>
					<DynamicDialog
						buttons={[saveButton]}
						open={irrigationOpen}
						labelId={"showIrrSystemDialog"}
						title={"Irrigation System"}
						textMessage={""}
						form={getPreIrrigationSysForm()}
					/>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					<DynamicDialog
						buttons={[saveButton]}
						open={waterOpen}
						labelId={"showWaterMgmtToolsDialog"}
						title={"Water Management Tools"}
						textMessage={""}
						form={getWaterMgmtToolsForm()}
					/>
				</GridItem>

				<GridItem xs={12} sm={12} md={12}>
					<div style={{ marginTop: "10px" }}>
						<InputLabel variant="standard" htmlFor="uncontrolled-native" color="primary">
							a. Cropping System
						</InputLabel>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					<div style={{ marginTop: "10px", marginRight: "20px", display: "inline-block" }}>
						<Button variant="contained" onClick={handleClickCroppingOpen} color="secondary">
							Select
						</Button>
					</div>
					<div id="cropComplete" style={{ display: "none", verticalAlign: "middle" }}>
						{" "}
						<img src={greencheckmarkicon}></img>
					</div>
				</GridItem>

				<GridItem xs={12} sm={12} md={12}>
					<div style={{ marginTop: "10px" }}>
						<InputLabel variant="standard" htmlFor="uncontrolled-native" color="primary">
							b. Irrigation System
						</InputLabel>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					<div style={{ marginTop: "10px", marginRight: "20px", display: "inline-block" }}>
						<Button variant="contained" onClick={handleClickIrrigationOpen} color="secondary">
							Select
						</Button>
					</div>
					<div id="irrcomplete" style={{ display: "none", verticalAlign: "middle" }}>
						{" "}
						<img src={greencheckmarkicon}></img>
					</div>
				</GridItem>

				<GridItem xs={12} sm={12} md={12}>
					<div style={{ marginTop: "10px" }}>
						<InputLabel variant="standard" htmlFor="uncontrolled-native" color="primary">
							c. Water Management Tools
						</InputLabel>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					<div style={{ marginTop: "10px", marginRight: "20px", display: "inline-block" }}>
						<Button variant="contained" onClick={handleClickWaterOpen} color="secondary">
							Select
						</Button>
					</div>
					<div id="watercomplete" style={{ display: "none", verticalAlign: "middle" }}>
						{" "}
						<img src={greencheckmarkicon}></img>
					</div>
				</GridItem>
			</GridContainer>
		</div>
	);
}
